import { REDEEM_EVENTS } from "@/events";
import { useEventListener, useDialogPortal, useProtocolStore } from "@/hooks";
import { useTokenForm } from "@/hooks";
import { TOKEN_IDS } from "@/types";

export function useRedeemForm({ initialAmount }: { initialAmount?: number }) {
    const { openRedeemFormDialogAlt, openRedeemTransactionDialog } = useDialogPortal();
    const {
        form,
        amount: redeemAmount,
        amountError: redeemAmountError,
        selectedTokenId,
        selectTokenId,
        setMaxAmount,
        resetAmount,
        isAmountOverBalance,
    } = useTokenForm({
        defaultTokenId: TOKEN_IDS.IUSD,
        initialAmount,
    });

    useEventListener(REDEEM_EVENTS.SUCCESS, resetAmount);
    const { stats } = useProtocolStore();

    const submitRedeem = form.handleSubmit(() => {
        const inputAmount = redeemAmount.value;
        const amount = Number(inputAmount);

        // At this point, we need to confirm that the protocol can satisfy the immediate request
        if (stats.asset.pendingRedemptionsAssetNormalized > 0 || stats.asset.totalLiquidAssetNormalized < amount) {
            const payload = {
                initialRedeemAmount: amount,
                ableToSatisfy:
                    stats.asset.totalLiquidAssetNormalized > 0 && stats.asset.pendingRedemptionsAssetNormalized === 0
                        ? stats.asset.totalLiquidAssetNormalized
                        : 0,
            };
            openRedeemFormDialogAlt(payload);
        } else {
            const payload = {
                redeemAmount: amount,
                redeemTokenId: selectedTokenId,
            };
            openRedeemTransactionDialog(payload);
        }
    });

    return {
        redeemAmount,
        redeemAmountError,
        selectedTokenId,
        submitRedeem,
        selectTokenId,
        setMaxAmount,
        isAmountOverBalance,
    };
}
